import ReactGA from "react-ga4";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { routeConfig } from "@monorepo/constants/routeConfig";
import { showErrorArrayTitles } from "@monorepo/helpers";
import { useCreateOrderMutation, useLazyGetActiveOrderQuery } from "@monorepo/services/api/order";
import i18n from "@monorepo/translations";
import { IService, IUpdateCartResponse } from "@monorepo/types";

export const useDeclaration = () => {
  const history = useHistory();
  const [createOrder] = useCreateOrderMutation();
  const [getActiveOrder] = useLazyGetActiveOrderQuery();
  const handleDeclarationConflictResolutionSuccess = ({
    service,
    res,
  }: {
    res?: IUpdateCartResponse;
    service: IService;
  }) => {
    ReactGA.event("add_to_list", { service_id: service.id });
    toast.success(i18n.t("common.service_succesfully_added"), {
      toastId: service.id,
    });
    const path = routeConfig.dashboard.payments.paymentOverview;
    if (!res) {
      return null;
    }
    createOrder({
      order_sum: String(res.data.attributes.sum),
      cart_count: "1",
      data_declaration: true,
      cart_id: [Number(res.data.id)],
    })
      .unwrap()
      .then(() => {
        ReactGA.event("declaration", {
          service_id: service.id,
        });

        getActiveOrder()
          .unwrap()
          .then((activeOrderRes) => {
            if (activeOrderRes) {
              history.push(path);
            }
          });
      })
      .catch((err) => {
        showErrorArrayTitles(err);
      });
  };
  return { handleDeclarationConflictResolutionSuccess };
};
